import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '@app/shared/services/auth/auth.service';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer-account',
  templateUrl: './customer-account.component.html',
  styleUrls: ['./customer-account.component.scss']
})
export class CustomerAccountComponent implements OnDestroy {
  userName: string;
  private masterSubscription: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private seoService: SEOService) {

    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'CUSTOMER-ACCOUNT.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'CUSTOMER-ACCOUNT.META-DESCRIPTION'
      }
    ]);

    const sub = this.authService.getUser$()
      .subscribe(user => {
        this.userName = user ? user.profile.preferred_username : '';
      });
    this.masterSubscription.add(sub);
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }
}
